import BaseTextField from "components/base/TextField"
import useInput from "hooks/use_input"
import BaseMask from "../../base/Mask"
import useTranslation from "../../../hooks/use_translation"

const Weight = () => {
  const id = "weight"

  const { fields } = useTranslation()

  const validate = (value) => {
    if (value === "") return fields?.required

    return ""
  }

  const { handleChange, inputValue, errorMessage, handleBlur } = useInput(id, validate)

  return (
    <BaseTextField
      required
      id={id}
      _label={fields?.weight_title}
      value={inputValue}
      onChange={handleChange}
      error={errorMessage?.length > 0}
      onBlur={handleBlur}
      helperText={errorMessage}
      InputProps={{
        inputComponent: BaseMask,
        inputProps: {
          mask: "000",
          placeholder: "80",
        },
      }}
    />
  )
}

export default Weight
